import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { ImageTypesComponent } from './image-types.component'
import { CreateImageTypeComponent } from './create-image-type/create-image-type.component'
import { UpdateImageTypeComponent } from './update-image-type/update-image-type.component'
import { imageTypesRoutes } from './image-types.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { RadioModule } from '@components/radio/radio.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    ImageTypesComponent,
    CreateImageTypeComponent,
    UpdateImageTypeComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(imageTypesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    RadioModule,
    BreadcrumbsModule,
  ],
  exports: [
    ImageTypesComponent,
    CreateImageTypeComponent,
    UpdateImageTypeComponent,
  ],
})
export class ImageTypesModule {}
